import api from '../utils/api';

// Fetch all sections
export const getSections = async (headers) => {
  try {
    const response = await api.get('/api/sections',  headers );
    return response.data;
  } catch (error) {
    console.error('Error fetching all sections:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific section by ID
export const getSectionById = async (id, headers) => {
  try {
    const response = await api.get(`/api/sections/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error('Error fetching section by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new section
export const createSection = async (sectionData, headers) => {
  try {
    const response = await api.post('/api/sections', sectionData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating section:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing section
export const updateSection = async (id, sectionData, headers) => {
  try {
    const response = await api.put(`/api/sections/${id}`, sectionData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error updating section:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a section
export const deleteSection = async (id, headers) => {
  try {
    const response = await api.delete(`/api/sections/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error('Error deleting section:', error.response ? error.response.data : error.message);
    throw error;
  }
};
